module.exports = __webpack_public_path__ + "media/src/public/img/promo-slide-image-5c7235adfb782be5966c9f8d88b80323.png";